var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37437 11.105C3.37437 6.5558 7.07518 2.85499 11.6244 2.85499C16.1736 2.85499 19.8744 6.5558 19.8744 11.105C19.8744 15.6542 16.1736 19.355 11.6244 19.355C7.07518 19.355 3.37437 15.6542 3.37437 11.105ZM27.7203 25.2586L20.3049 17.8432C21.7528 15.9808 22.6232 13.6474 22.6232 11.1057C22.6232 5.03098 17.6979 0.105732 11.6232 0.105732C5.54842 0.105732 0.623169 5.03098 0.623169 11.1057C0.623169 17.1805 5.54842 22.1057 11.6232 22.1057C14.1649 22.1057 16.4982 21.2354 18.3607 19.7875L25.776 27.2029C26.0449 27.4717 26.3962 27.6057 26.7482 27.6057C27.1002 27.6057 27.4515 27.4717 27.7203 27.2029C28.2572 26.6659 28.2572 25.7955 27.7203 25.2586Z",
    fill: "#FB5B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.5fdaf35857df8edef92f316f077ec652.svg";
export { ForwardRef as ReactComponent };